/**
 * 文件工具函数
 * 根据url获取文件类型和扩展名
 */

/**
 * 从文件URL中提取文件扩展名
 * @param {string} fileUrl - 文件URL或文件路径
 * @returns {string} 文件扩展名（小写），如果无法提取则返回空字符串
 */
export const getFileExtension = (fileUrl: string): string => {
  if (!fileUrl || typeof fileUrl !== "string") {
    return "";
  }
  const urlPath = fileUrl.split("?")[0];
  const extension = urlPath.toLowerCase().split(".").pop();
  return extension || "";
};

/**
 * 根据文件扩展名获取对应的MIME类型
 * @param fileUrl 文件名或文件路径
 * @returns 对应的MIME类型，默认为 application/octet-stream
 */
export const getFileMimeType = (fileUrl: string): string => {
  if (!fileUrl) return "application/octet-stream";
  const extension = getFileExtension(fileUrl);

  const mimeTypes: Record<string, string> = {
    // 文档类型
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ppt: "application/vnd.ms-powerpoint",
    pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    txt: "text/plain",
    rtf: "application/rtf",

    // 图片类型
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    bmp: "image/bmp",
    webp: "image/webp",
    svg: "image/svg+xml",
    ico: "image/x-icon",

    // 音频类型
    mp3: "audio/mpeg",
    wav: "audio/wav",
    ogg: "audio/ogg",
    aac: "audio/aac",
    flac: "audio/flac",

    // 视频类型
    mp4: "video/mp4",
    avi: "video/x-msvideo",
    mov: "video/quicktime",
    wmv: "video/x-ms-wmv",
    flv: "video/x-flv",
    webm: "video/webm",

    // 压缩文件
    zip: "application/zip",
    rar: "application/x-rar-compressed",
    "7z": "application/x-7z-compressed",
    tar: "application/x-tar",
    gz: "application/gzip",

    // 其他
    json: "application/json",
    xml: "application/xml",
    html: "text/html",
    css: "text/css",
    js: "application/javascript",
    csv: "text/csv",
  };

  return mimeTypes[extension || ""] || "application/octet-stream";
};
